<template>
  <div class="container mx-auto my-2">
    <div class="row">
      <div v-for="rawMaterial in rawMatFamilies" :key="rawMaterial.id" class="card col-sm-3 text-bg-dark my-1 mx-auto"
        style="max-width: 300px; max-height: 750px"
        @click.prevent="showFormFamilies(rawMaterial.name, rawMaterial.description)">
        <!-- <div class="card-header">{{ rawMaterial.type }}</div> -->
        <img :src="serverUrl + 'images/forms/' + rawMaterial.image" class="rounded card-img-top img-fluid mt-3"
          style="width: 100%; height: 100%" :alt="rawMaterial" />
        <div class="card-body">
          <p class="card-title famTittle2">{{ rawMaterial.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      rawMatFamilies: [],
      serverUrl: RUTA_SERVIDOR,
    };
  },
  methods: {
    showFormFamilies(rawMat, rawDescription) {
      // console.log(rawDescription);
      this.$store.dispatch("setRawMatFamilyAction", rawMat);
      this.$store.dispatch("setRawMatDescriptionAction", rawDescription);
      this.$router.push("/FamilyForms");
    },
  },
  beforeMount() {
    axios
      .get(RUTA_SERVIDOR + "api/rawMaterial/list", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      //.then((res) => console.log(res.data))
      .then((res) => (this.rawMatFamilies = res.data))
      .catch((err) => console.log(`There has been an error ${err}`));
  },
};
</script>
<style scoped>
.card-img-top {
  max-height: 225px;
}

.famTittle2 {
  color: white;
  font-size: x-large;
  font-family: Georgia, serif;
  /* font-family: system-ui; */
  /* font-family: "Gill Sans", sans-serif; */
  /* font-family: serif; */
}
</style>
